import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/page-header";
import { AssetLibrary } from "@/features/assets";

export const Route = createFileRoute("/_authenticated/me/assets")({
  component: AssetsPage,
});

/** For when someone just needs the logo and is not writing anything. */
function AssetsPage() {
  return (
    <div>
      <PageHeader
        eyebrow="My space"
        title="Assets"
        description="Images your team has approved for anyone to use. Download one and add it on LinkedIn."
      />
      <AssetLibrary />
    </div>
  );
}
